import { CheckOutlined, CloseOutlined } from '@mui/icons-material';
import { Chip } from '@mui/material';
import React from 'react';
export const CcmConsentStatus = ({ consentStatus }) => {
    // start with "No Consent" defaults
    let backgroundColor = '#FFFDFD';
    let chipIcon = null;
    let textColor = '#00000099';
    let borderColor = '#00000099';
    if (consentStatus === 'Opt Out') {
        backgroundColor = '#FFFFFF';
        chipIcon = React.createElement(CloseOutlined, { style: { color: '#D32F2F', fontSize: '16px' } });
        textColor = '#D32F2F';
        borderColor = '#D32F2F';
    }
    if (consentStatus === 'Consented') {
        backgroundColor = '#FFFFFF';
        chipIcon = React.createElement(CheckOutlined, { style: { color: '#018FB7', fontSize: '16px' } });
        textColor = '#018FB7';
        borderColor = '#018FB7';
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Chip, { label: 'CCM', variant: 'outlined', size: 'small', ...(chipIcon ? { icon: chipIcon } : {}), style: {
                color: textColor,
                borderRadius: '6px',
                borderColor: borderColor,
                backgroundColor: backgroundColor,
                width: '64px',
                fontWeight: '700',
                fontSize: 'x-small'
            } })));
};
